import {
  FilterType,
  buildTrainingsDataTableFilter,
  useTrainingsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

export const dateFilter = (source: ReturnType<typeof useTrainingsDataTable>) => {
  return buildTrainingsDataTableFilter(source, {
    identifier: 'dateFilter',
    title: i18n.t('trainings.training_catalog.datatable.date_filter'),
    path: 'createdAt',
    default: true,
    type: FilterType.Date,
    categories: [
      {
        kind: 'DatePicker',
        operation: 'between',
      },
    ],
  })
}
